export const HotspotQuestionNote = {
  TextEntryInteraction:
    "Each marker on the image corresponds to a labeled text box below. Type the correct label in the matching text box.",
  ChoiceInteraction:
    "Each marker on the image corresponds to a labeled dropdown below. Select the correct label from the matching dropdown list.",
  PositionObjectInteraction:
    "Click to pick a label, and click again to drop it in the correct spot on the image",
};
